<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'modals.suppliers.settings.title' | translate }}
    v-card-content
      v-text-field.mb-3(
        :label="$t('base.first_name')"
        v-model="form.name")
      v-select.mb-3(
        :label="$t('base.type')"
        :options="options"
        item-value="key"
        v-model="form.type")
      v-text-field(
        :label="$t('base.info')"
        v-model="form.info")
    v-card-actions
      v-btn(
        :disabled="!isNameValid || !isTypeSelected"
        :loading="loading"
        @click="onUpdate").mr-2 {{ 'actions.save' | translate }}
      delete-btn(
        v-permission-hide="permissions.delete_provider"
        @delete="onDelete")
</template>

<script>
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'
import permissions from '@/util/permissions'
import { translateError } from '@/util/utils'

export default {
  name: 'SettingsModal',

  components: {
    DeleteBtn
  },

  props: {
    item: Object
  },

  mounted () {
    this.form.name = this.item.name
    this.form.type = this.item.type
    this.form.info = this.item.info
  },

  data: () => ({
    form: {
      name: '',
      type: null,
      info: ''
    },
    options: [
      { name: 'constants.provider_types.buyer', key: 'buyer' },
      { name: 'constants.provider_types.provider', key: 'provider' }
    ],
    loading: false,
    permissions: permissions
  }),

  computed: {
    isNameValid () {
      return !!this.form.name
    },

    isTypeSelected () {
      return this.form.type !== null
    }
  },

  methods: {
    async onUpdate () {
      this.loading = true
      const payload = {
        name: this.form.name,
        type: this.form.type,
        info: this.form.info
      }
      const { data, error } = await this.$store.dispatch('updateProvider', { id: this.item.id, payload })
      this.loading = false
      if (error) {
        for (const key in data) {
          for (const msg of data[key]) {
            this.$toasted.show(translateError(this, key, msg), {
              position: 'bottom-center',
              duration: 5000
            })
          }
        }
      } else {
        this.$emit('close')
      }
    },

    async onDelete () {
      const { error } = await this.$store.dispatch('deleteProvider', { id: this.item.id })
      if (!error) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
